<template>
  <Main>
    <div class="ma-12">
      <FixedHeaderTable
          title="KPIs Database"
          :data="kpiTypes"
          :headers="headers">
      </FixedHeaderTable>
    </div>
  </Main>
</template>

<script setup>
import Main from "@/Layouts/Main.vue";
import FixedHeaderTable from "../../Shared/FixedHeaderTable.vue";
import StringManipulation from "../../Mixins/StringManipulation";

const props = defineProps({
  kpiTypes: {
    type: Array,
    required: true
  }
})

const headers = [
  {title: 'Name', key: 'name'},
  {title: 'Functional unit', key: 'functional_unit'}
]


</script>

<style scoped>
</style>